import { useQuery } from '@tanstack/react-query'
import Service from 'Service'
import useStores from 'hooks/useStores'
import { invoicesQueryKey } from './queryKeys'

export { invoicesQueryKey } from './queryKeys'

export function useInvoicesQuery(initial = 0, take = 500) {
  const { companyStore } = useStores()
  const companyKey = companyStore.selectedCompany?.Keycompany

  return useQuery({
    queryKey: invoicesQueryKey(companyKey, initial, take),
    queryFn: async () => {
      const data = await Service.InvoiceDocuments.getAll(initial, take)
      return Array.isArray(data) ? data : []
    },
    enabled: Boolean(companyKey)
  })
}
